module.exports = __webpack_public_path__ + "static/media/ve.ce283431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ve.png
// module id = 2016
// module chunks = 0